module.exports = __webpack_public_path__ + "static/media/Remove-Plant.0cc9a894.svg";